import * as React from 'react';
import { useEffect, useState } from 'react';
import { Modal } from 'antd';
import './style.less';

type AdInfo = {
  adsId: string,
  sizes: any[],
  divId: string,
};

type Props = {
  desktop: AdInfo,
  mobile: AdInfo,
  divId: string,
};

const AdsOutOfPage = ({ desktop, mobile, divId }: Props) => {
  const [show, setShow] = useState(false);
  const [width, setWidth] = useState(1024);
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true);
    
    if (isClient) {
      let adsId, sizes;
      const mobileView = !window.matchMedia('(min-width: 768px)').matches;

      let width;

      if (mobileView) {
        ({ adsId, sizes } = mobile);
        width = 320;
      } else {
        ({ adsId, sizes } = desktop);
        width = 1024;
      }

      if (!adsId || !sizes) {
        return;
      }

      let eventHandler;
      let slot;

      window.googletag = window.googletag || { cmd: [] };
      googletag.cmd.push(function () {
        slot = googletag
          .defineSlot(adsId, sizes, divId)
          .addService(googletag.pubads());

        googletag.pubads().enableSingleRequest();
        googletag.pubads().collapseEmptyDivs();
        googletag.pubads().setForceSafeFrame(false);
        googletag.enableServices();

        eventHandler = function (event) {
          if (slot === event.slot && !event.isEmpty) {
            try {
              width = parseInt(
                document
                  .getElementById(divId)
                  .getElementsByTagName('iframe')[0]
                  .getAttribute('width')
              );
            } catch (e) {
              console.log(e);
            }
            setWidth(width);
            setShow(true);
          }
        };
        googletag.pubads().addEventListener('slotRenderEnded', eventHandler);

        googletag.cmd.push(function () {
          googletag.display(divId);
        });
      });

      return () => {
        console.log('destroySlots');
        googletag.pubads().removeEventListener('slotRenderEnded', eventHandler);
        googletag.destroySlots([slot]);
      };
    }
  }, [isClient]);
  
  return (
      <Modal
        visible={show}
        footer={null}
        width={width}
        className={"oop-ads-modal"}
        onCancel={() => setShow(false)}
        forceRender={isClient}
      >
        <div id={divId} />
      </Modal>
    );
};

export default AdsOutOfPage;
